import React, { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

const AuthContext = createContext();

export function AuthProvider({ children }) {
	const [user, setUser] = useState(null);
	const [session, setSession] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let mounted = true;

		async function getInitialSession() {
			const { data } = await supabase.auth.getSession();
			if (!mounted) return;
			setSession(data?.session ?? null);
			setUser(data?.session?.user ?? null);
			setLoading(false);
		}

		getInitialSession();

		const { data: listener } = supabase.auth.onAuthStateChange((_event, newSession) => {
			// `newSession` is the session object itself, not `{ session }`
			setSession(newSession ?? null);
			setUser(newSession?.user ?? null);
		});

		return () => {
			mounted = false;
			listener?.subscription?.unsubscribe();
		};
	}, []);

	return <AuthContext.Provider value={{ user, session, loading }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
	return useContext(AuthContext);
}
